<template>
  <div class="home">
    1111
  </div>
</template>

<script>
import { Button,Icon,Col, Row } from 'vant';
export default {
  name: 'Home',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Row.name]: Row
  }
}
</script>
<style lang="less">
  .text{font-size: 12px ;/*no*/ background: #eee;border: 10px solid #f30000; /*no*/}
</style>
